export default __webpack_public_path__ + "static/media/miner.42a34065.png";